// The trade of one Data Core (R776, R1458).
//
// A core completes a fixed amount of research work on the active node, and
// the game discards what the node does not need (R21). This is the pure
// arithmetic of that trade, in WORK seconds: the caller turns work into
// world time with `GameState.buildSec`, the way every menu does (R688).
// Two cards read it, the USE CORE card of FLEET · EXPEDITIONS and the
// top-bar core card, so the two cannot state two figures.

import { DATA_CORE_WASTE_WARN_SHARE } from '../../gen/presentation';

/** What one core does to one node, in work seconds. */
interface CoreTrade {
  /** The work the core completes on the node. */
  gain: number;
  /** The work of the core that the node does not need, and the game discards. */
  lost: number;
  /** `lost` as a share of the whole core, 0..1. */
  share: number;
  /** More than the warn share of the core is lost (R1458). */
  warn: boolean;
}

/**
 * The trade of one core of `worth` work seconds on a node with `left` work
 * seconds to go. It is null when the server sent no figure (`worth` 0, a
 * server older than R776): the card then states no figure at all.
 */
export function coreTrade(
  worth: number, left: number, warnShare: number = DATA_CORE_WASTE_WARN_SHARE,
): CoreTrade | null {
  if (!(worth > 0)) return null;
  const rest = Math.max(0, left);
  const lost = Math.max(0, worth - rest);
  const share = lost / worth;
  return { gain: Math.min(worth, rest), lost, share, warn: share > warnShare };
}
